import { Page, Widget } from "@pulsex/types";

const findWidgetByStyle = (
  widgets: Widget[],
  style: string | string[]
): Widget | null => {
  if (Array.isArray(style)) {
    return widgets.find((item: Widget) => style.includes(item.style)) || null;
  } else {
    return widgets.find((item: Widget) => item.style === style) || null;
  }
};

function groupWidgetsByPattern(widgetsData: any) {
  const groupedWidgets: Record<string, Widget[]> = {};
  const patterns = [
    {
      regex: /^(\w+)-inside-banner(?:-(\w+))?$/,
      keySuffix: "WidgetInsideBanners",
    },
    {
      regex: /^([\w-]+)-aside-column(?:-([\w-]+))?$/,
      keySuffix: "WidgetColumnAsides",
    },
  ];

  widgetsData?.widgets.forEach((item: any) => {
    patterns.forEach((patternInfo) => {
      const match = item?.style?.match(patternInfo.regex);

      if (match) {
        const baseKey = match[1];
        const suffix = match[2] || "";
        const style = suffix
          ? `${baseKey}-inside-banner-${suffix}`
          : `${baseKey}-inside-banner`;

        let finalStyleForLookup = style;

        if (patternInfo.regex.source.includes("aside-column")) {
          finalStyleForLookup = suffix
            ? `${baseKey}-aside-column-${suffix}`
            : `${baseKey}-aside-column`;
        }

        if (!groupedWidgets[baseKey]) {
          groupedWidgets[baseKey] = [];
        }
        const widget = findWidgetByStyle(
          widgetsData.widgets,
          finalStyleForLookup
        );
        if (widget) {
          groupedWidgets[baseKey].push(widget);
        }
      }
    });
  });

  const result: Record<string, Widget[]> = {};
  Object.entries(groupedWidgets).forEach(([key, widgets]) => {
    const bannerWidgets = widgets.filter((widget) =>
      widget?.style?.includes("inside-banner")
    );
    if (bannerWidgets.length > 0) {
      result[`${key}WidgetInsideBanners`] = bannerWidgets;
    }
    const asideColumnWidgets = widgets.filter((widget) =>
      widget?.style?.includes("aside-column")
    );
    if (asideColumnWidgets.length > 0) {
      result[`${key}WidgetAsideColumn`] = asideColumnWidgets;
    }
  });

  return result;
}
export const getWidgetGrouping = (widgetsData: any) => {
  // @ts-ignore
  widgetsData.widgets = widgetsData.widgets.map((widget) => {
    if (widget.code === "recommended")
      return {
        ...widget,
        style: "aside/recommended",
      };
    return widget;
  });

  if (widgetsData?.widgets?.length) {
    const groupedPatterns = groupWidgetsByPattern(widgetsData);

    return {
      asidePostsWidget: findWidgetByStyle(
        widgetsData.widgets,
        "aside-posts-widget"
      ),
      asideStatsWidget: findWidgetByStyle(
        widgetsData.widgets,
        "aside-stats-widget"
      ),
      authorWork: findWidgetByStyle(widgetsData.widgets, "author-work"),
      pdfDetailsContent: findWidgetByStyle(
        widgetsData.widgets,
        "pdf-details-content"
      ),
      groupedPatterns,
      asideMostReadWidget: findWidgetByStyle(
        widgetsData.widgets,
        "details-most-read-widget"
      ),
      urgentNewsAside: findWidgetByStyle(
        widgetsData.widgets,
        "urgent-news-widget"
      ),
    };
  }
};
